var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnergetic = function SvgEnergetic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.184 14.351H8.461a1.485 1.485 0 0 1-1.477-1.477c0-.273.077-.542.22-.774l5.225-8.493A.75.75 0 0 1 13.82 4v5.65h1.721c.81 0 1.478.668 1.478 1.478 0 .273-.077.541-.22.774l-5.225 8.492a.75.75 0 0 1-1.389-.393v-5.65zm2.134-7.7-3.815 6.2h2.431a.75.75 0 0 1 .75.75v3.75l3.816-6.2h-2.432a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd"
  })));
};
export default SvgEnergetic;